import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useAuth } from "../lib/auth";
import { pushState, currentSubscription, enablePush } from "../lib/push";

const KEY = "jatak_push_prompt_done";

export default function PushPrompt() {
  const { store } = useAuth();
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (store?.staff || store?.is_owner || localStorage.getItem(KEY) || pushState() !== "ok" || Notification.permission !== "default") return;
    currentSubscription().then((s) => setShow(!s)).catch(() => {});
  }, [store]);
  if (!show) return null;
  const done = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const enable = async () => {
    setBusy(true);
    try { await enablePush(); } catch { /* denied/unsupported: settings explains */ }
    done();
  };
  return (
    <section className="pp" data-testid="push-prompt">
      <span className="pp-ico"><Bell size={18} /></span>
      <p>Vil du have besked, når kunderne siger ja tak?</p>
      <div className="pp-btns">
        <button type="button" className="btn primary small" onClick={enable} disabled={busy} data-testid="push-prompt-enable">Slå til</button>
        <button type="button" className="btn small" onClick={done} data-testid="push-prompt-dismiss">Ikke nu</button>
      </div>
    </section>
  );
}
